import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import Dashboard from "../../common/components/layout/Dashboard";
import { NfsDashboard } from ".";

function NfsDetailsPage() {

    return (
        <ToastProvider>
            <Dashboard>
                <NfsDashboard />
            </Dashboard>
            <Toast />
        </ToastProvider>
    )
}

export default NfsDetailsPage;